import React, { ErrorInfo } from "react"
import * as Sentry from "@sentry/react"
import ErrorPage from "./ErrorPage"

type State = { hasError: boolean; error?: unknown }

class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, error }
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("App ErrorBoundary caught: ", error, info)
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: info.componentStack,
        },
      },
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          title="Unexpected error"
          message="Please refresh the page or try again later."
        />
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
